<mat-sidenav-container class="h-100">
    <mat-sidenav #nav mode="push" class="h-100">
    </mat-sidenav>
    <mat-sidenav-content class="d-flex flex-column">
        <app-header [nav]="nav"></app-header>
        <main>
          <router-outlet></router-outlet>
        </main>
        <app-footer></app-footer>
    </mat-sidenav-content>
</mat-sidenav-container>
